import React from 'react'
import InquiriesDataTable from "../../components/Admin/Inquiries"

const Inquiries = () => {
  return (
    <InquiriesDataTable />
  )
}

export default Inquiries;